export default __webpack_public_path__ + "static/media/carIconBlack.f4cfb53b.svg";